import { QrAssets } from '../models/qrAssets';
import { QrAssetsUnparsed } from '../models/qrAssetsUnparsed';

export const payloadToQrAssets = ({ qr }: QrAssetsUnparsed): QrAssets => {
  return {
    qr,
  };
};
